import { DialogActions as MuiDialogActions } from '@mui/material';

export default MuiDialogActions;
